<template>
    <b-row>
        <b-col cols="12">
            <b-alert variant="success"
                     show
                     v-if="rapidlyDegradable === true"
            >
                <h6 class="font-weight-bold">
                    <i class="fa fa-check"/>
                    PRODUCTO RÁPIDAMENTE DEGRADABLE
                </h6>
            </b-alert>

            <b-alert variant="warning"
                     show
                     v-else-if="rapidlyDegradable === false"
            >
                <h6 class="font-weight-bold">
                    <i class="fa fa-warning"/>
                    PRODUCTO NO RÁPIDAMENTE DEGRADABLE
                </h6>
            </b-alert>

            <b-alert variant="danger"
                     show
                     v-else
            >
                <h6 class="font-weight-bold">
                    <i class="fa fa-warning"/>
                    NO SE PUEDE DETERMINAR DEGRADABILIDAD DEL PRODUCTO
                </h6>
            </b-alert>
        </b-col>

        <b-col cols="12">
            <table class="table table-sm"
                   v-if="!!question_groups.length && !!question_groups[0].questions.length"
            >
                <thead>
                <tr class="font-weight-bold text-white bg-soluquim">
                    <th></th>
                    <th colspan="3">RESPUESTA</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(question) in question_groups[0].questions">
                    <td>
                        {{ question.question }}
                    </td>
                    <td>
                        <b-form-radio v-model="question.answer"
                                      class="radio_true"
                                      :value="true"
                                      :state="true"
                                      @change="disableAnswers(question)"
                        >
                            Si
                        </b-form-radio>
                    </td>
                    <td>
                        <b-form-radio v-model="question.answer"
                                      class="radio_false"
                                      :value="false"
                                      :state="false"
                                      @change="disableAnswers(question)"
                        >
                            No
                        </b-form-radio>
                    </td>
                    <td>
                        <b-form-radio v-model="question.answer"
                                      class="radio_false"
                                      :value="null"
                                      :state="false"
                                      @change="disableAnswers(question)"
                        >
                            No hay datos
                        </b-form-radio>
                    </td>
                </tr>
                </tbody>
            </table>

            <b-row>
                <b-col class="text-center">
                    <b-button variant="primary"
                              size="sm"
                              class="mx-1"
                              @click="_saveAnswers()"
                    >
                        Guardar <i class="fa fa-save"/>
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'factor_m',
    data() {
        return {
            component: null,
            cat1: 0,
            cat2: 0,
            cat3: 0,
            result: null
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'only_view',
            'grouped_components',
            'classification',
            'question_groups'
        ]),
        rapidlyDegradable() {
            if (!this.question_groups.length) return;

            let rapidly_degradable = this.question_groups[0].questions.some(q => q.answer === true);

            if (!rapidly_degradable) {
                let not_rapidly_degradable = this.question_groups[0].questions.some(q => q.answer === false);

                if (!not_rapidly_degradable) {
                    return null;
                }

                return false;
            }

            return true;
        }
    },
    async mounted() {
        await this.getGroupedComponents();

        this.setQuestionsIndex(0);
        this.setDangerCode('MCAL39');
        await this.getQuestionGroups('GQ14');
        this.setCodeQuestionGroup('GQ14');

        this.disableAnswers();
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateComponents',
            'getGroupedComponents',
            'getClassification',
            'getAnswers',
            'getQuestionGroups',
            'saveAnswers'
        ]),
        ...mapMutations('calculator', [
            'setQuestionsIndex',
            'clearAnswers',
            'setCodeQuestionGroup',
            'setDangerCode',
            'setBasicQuestionGroups'
        ]),
        disableAnswers(question = null) {
            if (!this.question_groups.length) return;

            let question_groups = JSON.parse(JSON.stringify(this.question_groups));

            let disabled = null;
            let properties = this.product.properties;

            if (!isNaN(parseFloat(properties.dbo5)) && !isNaN(parseFloat(properties.dqo)) && properties.dqo > 0) {
                disabled = (properties.dbo5 / properties.dqo) > 0.5;
            }

            question_groups[0].questions.map(q => {
                if (question && question.code === q.code) {
                    q.disabled = false;
                } else if (!question && q.answer !== null) {
                    q.disabled = false;
                } else if (q.code === 'QCAL126' && disabled !== null) {
                    q.disabled = !!disabled;
                } else {
                    q.disabled = this.rapidlyDegradable !== null;
                }
            });

            this.setBasicQuestionGroups(question_groups);
        },
        async _saveAnswers() {
            await this.saveAnswers(0);
        }
    }
};
</script>

<style scoped>

</style>
